import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { BackgroundImageCardProps } from './types/BackgroundImageCard.types';
import '../BackgroundImageCard/BackgroundImageCard.scss';
import CardBox from './CardBox';
import LazyLoading from '../../LazyLoading/LazyLoading';
import { Waypoint } from 'react-waypoint';

const BackgroundImageCard = (props: BackgroundImageCardProps): JSX.Element => {
  const { fields } = props;
  const [bgWaypoint, setBgWaypoint] = useState(false);
  const [cardBoxWaypoint, setCardBoxWaypoint] = useState(false);
  useEffect(() => {
    if (props?.skipAnimation) {
      setBgWaypoint(true);
      setCardBoxWaypoint(true);
    }
  }, []);

  const WaypointComponent: FC = useMemo(() => {
    return function Component() {
      return (
        <Waypoint
          onEnter={({ event }) => {
            if (event) setBgWaypoint(true);
          }}
        />
      );
    };
  }, []);

  return (
    <article className={'BackgroundImageCard__external'}>
      <WaypointComponent />

      {fields?.title && (
        <RichText
          tag={'h1'}
          field={fields.title}
          className={`BackgroundImageCard__title title-section-xl 
						${bgWaypoint ? 'BackgroundImageCard__slide_animation' : ''}`}
          style={props.titleColor && { color: props.titleColor }}
        />
      )}
      {fields?.subtitle && (
        <RichText
          tag={'span'}
          className={`BackgroundImageCard__subtitle 
						${bgWaypoint ? 'BackgroundImageCard__slide_animation' : ''}`}
          style={
            props.titleColor === 'black'
              ? { color: '$434343' }
              : { color: props.titleColor }
          }
          field={fields.subtitle}
        />
      )}
      <div
        className={`BackgroundImageCard__bg_wrapper 
					${bgWaypoint ? 'BackgroundImageCard__slide_animation' : ''} `}
      >
        <Waypoint
          onEnter={({ event }) => {
            if (event) {
              setCardBoxWaypoint(true);
            }
          }}
          fireOnRapidScroll={true}
        />
        <div className="BackgroundImageCard__bg">
          <LazyLoading field={fields.image} />
          <span
            className={`BackgroundImageCard__image_heading 
							${bgWaypoint ? 'BackgroundImageCard__slide_animation' : ''}`}
          >
            {fields.imageHeading && fields.imageHeading}
          </span>
          {fields.cardIcon && (
            <span
              className={`icon ${fields.cardIcon} BackgroundImageCard__icon`}
            />
          )}
        </div>
        <CardBox
          cssClass={props.cssClass && props.cssClass}
          cardTitle={props.fields.cardTitle && props.fields.cardTitle}
          cardContent={props.fields.cardContent && props.fields.cardContent}
          cardIcon={props.fields.cardIcon && props.fields.cardIcon}
          ctaText={props.fields.ctaText && props.fields.ctaText}
          animationClass={'BackgroundImageCard__slide_animation'}
          enteredWaypoint={cardBoxWaypoint}
          isHidden={props?.hiddenBox}
        />
      </div>
    </article>
  );
};

export default BackgroundImageCard;
